import { lazy } from 'react';

/**
 * Code-split boundary for the share-details modal.
 *
 * The modal pulls in `SmartUserPicker` and the people-recommendation
 * client, which together are heavy enough that we don't want them in
 * the main chat chunk. Loading on first open trades a one-shot chunk
 * fetch for a meaningful reduction in initial bundle size for users who never open it.
 */
export const ShareConversationModalLazy: ReturnType<typeof lazy> = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_conversation-assistant" */ '@atlassian/conversation-assistant-ui-components/ui/ShareConversationModal'
	).then((module) => ({ default: module.ShareConversationModal })),
);
